// Libraries
var React = require('react');

// Components
var OptaWidget = require('../OptaWidget/OptaWidget');

// Styles
require('./MatchAveragePositions.scss');

class MatchAveragePositionsModule extends React.Component {
    
	render() {
        return (
            <div className="MatchAveragePositions">
                <h2>Average Positions</h2>
                <OptaWidget language={this.props.data.language} timezone={this.props.data.timezone} subscriptionId={this.props.data.subscriptionId} properties={this.props.data.properties}/>
            </div>)
    }
}
    
module.exports = MatchAveragePositionsModule;


// WEBPACK FOOTER //
// ./src/components/MDC/MatchAveragePositions/MatchAveragePositionsModule.js